import { ITransientAccessCred } from '../builders/transient_access_cred_builder';
import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export type TransientAccessCredModel = ITypedModel<ITransientAccessCred>;

angular.module('capability-ng-scheduler').factory(
  'ngTransientAccessCredModel',
  (): TransientAccessCredModel =>
    new Model<ITransientAccessCred>({
      username: '',
      password: ''
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/prevent_transient_access/models/transient_access_cred_model.ts